import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useBackerApi } from '../../api';
import { backerKeys } from '../../query-key-factory';

const useConsumerSubscribeToCause = () => {
  const BackerApi = useBackerApi();
  const queryClient = useQueryClient();

  const update = async ({ causeId, token }: { causeId?: string; token?: string }) => {
    const queryParams = new URLSearchParams();
    if (causeId) queryParams.set('cause_id', causeId);
    if (token) queryParams.set('token', token);

    const { data } = await BackerApi.put<{ status: string }>(
      `/consumer/communications/status?${queryParams.toString()}`
    );
    return data;
  };

  return useMutation({
    mutationFn: update,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: backerKeys.consumer.communicationStatus.all });
      void queryClient.invalidateQueries({ queryKey: backerKeys.consumer.lists.all });
    },
  });
};

export { useConsumerSubscribeToCause };
